<template>
  <article>
    <div class="fs-24">{{detail.title}}</div>
    <div class="dataForm mt-20">
      <div class="flex">
        <div class="dataForm__item flex-1">
          <div class="dataForm__name">低价折扣:</div>
          <div class="">{{detail.min_discount}}%</div>
        </div>
        <div class="dataForm__item flex-1">
          <div class="dataForm__name">折扣:</div>
          <div class="">{{detail.discount}}%</div>
        </div>
        <div class="dataForm__item flex-1">
          <div class="dataForm__name">投放时间:</div>
          <div class="">{{detail.start_time}} - {{detail.end_time}}</div>
        </div>
      </div>
      <div class="flex mt-10">
        <div class="dataForm__item flex-1">
          <div class="dataForm__name">完成截图提交时间:</div>
          <div class="">{{detail.apply_time}}天</div>
        </div>
        <div class="dataForm__item flex-1">
          <div class="dataForm__name">完成截图提交时间:</div>
          <div class="">{{detail.effective_time}}天</div>
        </div>
        <div class="dataForm__item flex-1">
          <div class="dataForm__name">返现周期:</div>
          <div class="">{{detail.cashback_cycle}}</div>
        </div>
      </div>
      <div class="flex mt-10">
        <div class="dataForm__item">
          <div class="dataForm__name">下单链接:</div>
          <a class="underline fc-blue" target="_blank" href="http://baidu.com">{{detail.link}}</a>
        </div>
      </div>
    </div>
    <div class="base mt-30">
      <div class="base__container">
        <div v-for="(item, index) in baseList" class="base__item" :key="index">
          <div class="base__name">{{item.name}}</div>
          <div class="base__value">{{item.value}}</div>
        </div>
      </div>
    </div>
    <div class="filter mt-20">
      <div class="filter__item">
        <div class="filter__name">名字：</div>
        <el-input v-model="filters.name" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">用户UID：</div>
        <el-input v-model="filters.uid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">时间：</div>
        <el-date-picker
            v-model="filters.dateTime"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions" size='small'>
          </el-date-picker>
      </div>
      <div class="filter__item">
        <div class="filter__name">状态：</div>
        <el-select class="filter__input" size="mini" v-model="filters.status">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in statusList" :key="index"></el-option>
        </el-select>
      </div>
      <button class="blue-small-btn" @click="getList">搜索</button>
    </div>
    <el-table :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="mt-30" height="600">
      <el-table-column prop="uid" label="用户ID" width="" align="center">
      </el-table-column>
      <el-table-column label="昵称" width="" align="center">
        <template slot-scope="scope">
          <router-link :to="{path: '/adUserDetail', query: {uid: scope.row.uid}}">{{scope.row.nickname}}</router-link>
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="头像" width="110" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.headimgurl" width="60" height="60">
        </template>
      </el-table-column>
      <el-table-column prop="real_name" label="用户名" width="" align="center">
      </el-table-column>
      <el-table-column prop="ocount" label="订单数" width="" align="center">
      </el-table-column>
      <el-table-column prop="payment" label="总报单金额" width="" align="center">
      </el-table-column>
      <el-table-column prop="commission" label="总佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="final_payment" label="总实付金" width="" align="center">
      </el-table-column>
      <!--
      <el-table-column prop="check_count" label="总订单" width="" align="center">
      </el-table-column>
      <el-table-column prop="check_success_count" label="有效订单" width="" align="center">
      </el-table-column>
      <el-table-column prop="check_cost" label="总佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="check_success_cost" label="有效佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="check_refuse_count" label="拒绝佣金" width="" align="center">
      </el-table-column>
      <el-table-column prop="exchange_success_cost" label="已打款" width="" align="center">
      </el-table-column>
      <el-table-column prop="" label="接单时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      -->
      <el-table-column label="操作" width="80" align="center" fixed="right">
        <template slot-scope="scope">
          <router-link class="blue-small-btn" :to="{path: '/adOrder', query: {adid: adid, uid: scope.row.uid}}">明细</router-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
  </article>
</template>

<script>
import mixinList from '../../../mixins/list'
import util from '../../../script/util'
import {adDetail, adOrderUserLists} from '../../../api/api'
export default {
  name: 'adDetail',
  mixins: [mixinList],
  data () {
    return {
      baseList: [
        {
          name: '总额度',
          ename: 'quota',
          value: 0
        },
        {
          name: '总报单金额',
          ename: 'payment',
          value: 0
        },
        {
          name: '总丢单金额',
          ename: 'invalid_quota',
          value: 0
        },

        {
          name: '总剩余额度',
          ename: 'remain_quota',
          value: 0
        },

        {
          name: '当日额度',
          ename: 'tquota',
          value: 0
        },
        {
          name: '当日报单金额',
          ename: 'tpayment',
          value: 0
        },
        {
          name: '当日丢单金额',
          ename: 'invalid_tquota',
          value: 0
        },
        {
          name: '当日剩余额度',
          ename: 'remain_tquota',
          value: 0
        },
        {
          name: '订单数',
          ename: 'check_count',
          value: 0
        },
        {
          name: '跟单中',
          ename: 'running_count',
          value: 0
        }
      ],
      adid: 0,
      detail: {
        icon: '',
        min_discount: '',
        discount: '',
        quota: '',
        tquota: '',
        remain_quota: '',
        remain_tquota: '',
        apply_time: '',
        effective_time: '',
        cashback_cycle: 0,
        link: ''
      },
      lists: [],
      listLoading: false,
      filters: {
        p: 1,
        l: 20,
        total: 0,
        status: '',
        dateTime: '',
        start_time: '',
        end_time: '',
        name: '',
        uid: ''
      },
      // 状态按钮
      statusList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '报单',
          value: 0
        },
        {
          name: '跟单中',
          value: 1
        },
        {
          name: '完成订单',
          value: 2
        },
        {
          name: '提现中',
          value: 3
        },
        {
          name: '已提现',
          value: 4
        },
        {
          name: '丢单',
          value: 5
        }
      ],
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            const end = new Date(new Date().setHours(0, 0, 0, 0))
            const start = new Date(new Date().setHours(0, 0, 0, 0))
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '昨天',
          onClick (picker) {
            const end = new Date(new Date().setHours(0, 0, 0, 0))
            const start = new Date(new Date().setHours(0, 0, 0, 0))
            end.setTime(end.getTime() - 3600 * 1000 * 24)
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date(new Date().setHours(0, 0, 0, 0))
            const start = new Date(new Date().setHours(0, 0, 0, 0))
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date(new Date().setHours(0, 0, 0, 0))
            const start = new Date(new Date().setHours(0, 0, 0, 0))
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date(new Date().setHours(0, 0, 0, 0))
            const start = new Date(new Date().setHours(0, 0, 0, 0))
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  methods: {
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time, false)
    },
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    dateTimeChange () {
      this.filters.start_time = parseInt(new Date(this.filters.dateTime[0]).getTime() / 1000)
      this.filters.end_time = parseInt(new Date(this.filters.dateTime[1]).getTime() / 1000)
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    adDetail () {
      let params = {
        adid: this.adid
      }
      this.loading = true
      adDetail(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.detail = data.d
          this.detail.start_time = this.formatTimeStamp(this.detail.start_time)
          this.detail.end_time = this.formatTimeStamp(this.detail.end_time)
          let that = this
          this.baseList.forEach((item) => {
            console.log(that.detail[item['ename']])
            item.value = that.detail[item['ename']]
          })
        }
        this.loading = false
      })
    },
    getList () {
      let filters = this.filters
      let params = {
        adid: this.adid,
        p: filters.p,
        l: filters.l
      }
      if (filters.name !== '') {
        params.nickname = filters.name
      }
      if (filters.uid !== '') {
        params.uid = filters.uid
      }
      if (filters.status !== '') {
        params.status = filters.status
      }
      if (filters.start_time !== '') {
        params.start_time = filters.start_time
      }
      if (filters.end_time !== '') {
        params.end_time = filters.end_time
      }
      adOrderUserLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      })
    }
  },
  mounted () {
    this.adid = parseInt(this.$route.query.adid || 0)
    if (this.adid) {
      this.adDetail()
      this.getList()
    }
  },
  watch: {
    'filters.dateTime': 'dateTimeChange'
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../style/color";
  .dataForm{
    border: 1px solid #e5e5e5;
    padding: 10px;
    border-radius: 10px;
    &__name{
      color: $blue;
      font-weight: bold;
    }
  }
  .base{
    &__container{
      display: flex;
      flex-wrap: wrap;
    }
    &__item{
      width: calc((100% - 20px * 3) / 4);
      text-align: center;
      box-sizing: border-box;
      border: 1px solid #e5e5e5;
      padding: 15px 0;
      border-radius: 10px;
      margin: 0 20px 20px 0;
      &:nth-of-type(4n){
        margin-right: 0;
      }
    }
    &__value{
      font-size: 24px;
      font-weight: 700;
      margin-top: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/module/ad/adDetail.vue